import Enumerable from "linq";
import {
  IItem,
  INumericRangeValidatable,
  instanceOfINumericRangeValidatable,
} from "../items";
import { NumericAlertKinds } from "../NumericAlertKinds";
import { IDocumentAlert } from "../IDocumentAlert";
import { NumericRangeAlert } from "../alerts";
import { AbstractItemValidator } from "./AbstractItemValidator";

export class NumericRangeValidator extends AbstractItemValidator {
  protected validateItem(item: IItem, itemSetId: number): IDocumentAlert[] {
    return Enumerable.from([
      !this.isValid(item) ? new NumericRangeAlert(itemSetId, item as IItem & INumericRangeValidatable) : null,
    ])
    .toArray();
  }

  private isValid(item: IItem): boolean {
    return !instanceOfINumericRangeValidatable(item)
      || (item.numericAlertKind === NumericAlertKinds.Color)
      || item.isNumericValueInRange();
  }

  public static isInRange(text: string, upperLimit: number, lowerLimit: number): boolean {
    const hasUpperLimit = (upperLimit !== null && upperLimit !== undefined);
    const hasLowerLimit = (lowerLimit !== null && lowerLimit !== undefined);
    if (!hasUpperLimit && !hasLowerLimit) { return true; }
    // V1の動作を確認してみると、文字が空の時は許容させている模様
    if (text === null || text === undefined || text === "") { return true; }
    try {
      const value = Number(text);
      if (!isFinite(value)) { return false; }
      if (hasUpperLimit) {
        // TODO:mathjs使ったほうがよい？
        if (value > upperLimit) { return false; }
      }
      if (hasLowerLimit) {
        // TODO:mathjs使ったほうがよい？
        if (value < lowerLimit) { return false; }
      }
      return true;
    } catch (e) {
      console.warn(e);
    }
    return false;
  }
}
